import { render } from "./BookRefsWidget.vue?vue&type=template&id=53d6a6f2&scoped=true"
import script from "./BookRefsWidget.vue?vue&type=script&lang=js"
export * from "./BookRefsWidget.vue?vue&type=script&lang=js"

import "./BookRefsWidget.vue?vue&type=style&index=0&id=53d6a6f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d6a6f2"]])

export default __exports__